import { getFormResponseTitle } from "../notificationTitles.service";


export interface IFormResponseTitle {
    user: string;
    isPopOut?: boolean
}

const FormResponseTitle = ({user, isPopOut}: IFormResponseTitle ) => {
    const {className, activityInformation} = getFormResponseTitle({user, isPopOut})
    
    return (
        <span className={className}>
            {activityInformation}
        </span>
    );
};
export default FormResponseTitle;
